/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function () {
  function initCard(card) {
    var wrap = card.querySelector('.product-card__image-wrap');
    var mainImg = card.querySelector('.product-card__image');
    var titleLink = card.querySelector('.product-card__title');

    function getInputForLabel(label) {
      var radioId = label.dataset.radioId || label.getAttribute('for');
      if (!radioId) return null;
      return card.querySelector('input[id="' + radioId + '"]');
    }

    function buildUrl(input) {
      var base = (wrap.dataset.url || '').split('?')[0];
      var variantId = input.dataset.variantId;
      return variantId ? base + '?variant=' + variantId : base;
    }

    function applyVariant(input) {
      if (!input) return;
      var src = input.dataset.image;
      if (src) {
        mainImg.src = src;
        mainImg.srcset = '';
      }
      var url = buildUrl(input);
      if (wrap) wrap.dataset.url = url;
      if (titleLink) titleLink.href = url;

      var radioId = input.id;
      var name = input.getAttribute('name');
      if (name) {
        card.querySelectorAll('input[name="' + name + '"]').forEach(function (el) {
          el.checked = false;
        });
      }
      card.querySelectorAll('input[id="' + radioId + '"]').forEach(function (el) {
        el.checked = true;
      });
    }

    function applyType(typeInput) {
      if (!typeInput) return;
      var typeName = typeInput.dataset.name;

      card.querySelectorAll('.variant.color').forEach(function (el) {
        el.style.display = el.dataset.name === typeName ? '' : 'none';
      });

      var firstChecked = card.querySelector('.variant.color[data-name="' + typeName + '"] input.variant-input:checked');
      if (!firstChecked) {
        firstChecked = card.querySelector('.variant.color[data-name="' + typeName + '"] input.variant-input');
      }
      if (firstChecked) applyVariant(firstChecked);

      var typeRadioId = typeInput.id;
      card.querySelectorAll('input[id="' + typeRadioId + '"]').forEach(function (el) {
        el.checked = true;
      });
    }

    if (wrap) {
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('input, .more_label')) return;

        var label = e.target.closest('.variant__label, .type__label');
        if (label) {
          var input = getInputForLabel(label);
          if (input && input.classList.contains('type-input')) {
            applyType(input);
          } else {
            applyVariant(input);
          }
        }

        window.location.href = wrap.dataset.url;
      });
    }

    if (!mainImg) return;

    var preloaded = false;
    card.addEventListener('mouseenter', function () {
      if (preloaded) return;
      preloaded = true;
      card.querySelectorAll('.variant__label').forEach(function (label) {
        var input = getInputForLabel(label);
        if (!input) return;
        var src = input.dataset.image;
        if (src) new Image().src = src;
      });
    }, { once: true });

    card.querySelectorAll('.variant__label').forEach(function (label) {
      label.addEventListener('mouseenter', function () {
        applyVariant(getInputForLabel(label));
      });
      label.addEventListener('click', function () {
        applyVariant(getInputForLabel(label));
      });
    });

    card.querySelectorAll('.type__label').forEach(function (label) {
      label.addEventListener('mouseenter', function () {
        applyType(getInputForLabel(label));
      });
      label.addEventListener('click', function () {
        applyType(getInputForLabel(label));
      });
    });
  }

  document.querySelectorAll('.product-card').forEach(initCard);
})();